import React, { useEffect, useState } from 'react';
import { ImageIcon } from 'lucide-react';
import PageHero from '../components/PageHero';
import PhotoGalleryView from '../components/PhotoGalleryView';
import { useTranslation } from '../i18nContext';
import { api } from '../lib/api';

export default function GalleryPage() {
  const t = useTranslation();
  const locale = t.locale;
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    api.get('/photo-galleries/gallery')
      .then(({ data }) => setDoc(data))
      .catch((err) => {
        if (err.response?.status === 404) setUnavailable(true);
        else setDoc(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const title = doc ? (locale === 'en' ? doc.title_en : doc.title_es) : (locale === 'es' ? 'Galería' : 'Gallery');

  return (
    <>
      <PageHero
        label="CMIC"
        title={title}
        subtitle={locale === 'es' ? 'Eventos, encuentros y vida del Colegio' : 'Events, gatherings and CMIC life'}
      />
      <section className="py-12 sm:py-16 bg-white" data-testid="gallery-page">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center py-16"><div className="w-8 h-8 border-3 border-cmic-200 border-t-cmic-500 rounded-full animate-spin" /></div>
          ) : unavailable ? (
            <div className="bg-cmic-50 border border-cmic-100 rounded-2xl p-12 text-center text-charcoal-500">
              <ImageIcon size={36} className="mx-auto mb-3 text-charcoal-300" />
              <p className="text-base font-medium text-charcoal-700">{locale === 'es' ? 'Galería próximamente' : 'Gallery coming soon'}</p>
              <p className="text-sm mt-1">{locale === 'es' ? 'Estamos preparando las fotografías de los eventos del Colegio.' : "We're preparing the College's event photos."}</p>
            </div>
          ) : (!doc || (doc.items || []).length === 0) ? (
            <div className="bg-cmic-50 border border-cmic-100 rounded-2xl p-12 text-center text-charcoal-500">
              <ImageIcon size={36} className="mx-auto mb-3 text-charcoal-300" />
              <p className="text-base">{locale === 'es' ? 'Aún no hay fotos en esta galería.' : 'No photos in this gallery yet.'}</p>
            </div>
          ) : (
            <PhotoGalleryView items={doc.items || []} viewMode={doc.view_mode || 'grid'} locale={locale} testidPrefix="gallery" shareable />
          )}
        </div>
      </section>
    </>
  );
}
